import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from "antd/es";
import { BgWrapperEditorInput } from "../../editor.style";
const CheckboxInput = ({ value, onChange, label = '', callback }) => {
    return (_jsx(BgWrapperEditorInput, { children: _jsx(Checkbox, { onChange: (event) => {
                onChange?.(event.target.checked);
                callback?.(event.target.checked);
            }, checked: value, children: label }) }));
};
export default CheckboxInput;
